import { useState } from 'react';

const FlagIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
    <line x1="4" y1="22" x2="4" y2="15"/>
  </svg>
);
const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const TYPES = [
  'Véhicule suspect', 'Intrusion', 'Altercation', 'Vol / Dégradation',
  'Éclairage défaillant', 'Barrière', 'Dépôt sauvage', 'Sanitaire', 'Autre',
];
const LOCALISATIONS = [
  '', 'Entrée principale', 'Zone PL — A', 'Zone PL — B',
  'Zone PL — C', 'Devant restaurant', 'Autre',
];

export default function VueSignalement({ onSuccess }) {
  const [form, setForm] = useState({
    type:        TYPES[0],
    niveau:      'moyen',
    description: '',
    localisation:'',
    plaque:      '',
  });

  const set = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  const handleSubmit = () => {
    if (!form.description.trim()) {
      alert('Veuillez renseigner une description.');
      return;
    }
    // TODO: axios.post('/api/signalements', { ...form })
    onSuccess?.();
    setForm({ type: TYPES[0], niveau: 'moyen', description: '', localisation: '', plaque: '' });
  };

  const niveaux = [
    { id: 'faible', label: 'Faible', style: {} },
    { id: 'moyen',  label: 'Moyen',  style: { borderColor:'var(--pg-amber)', background:'var(--pg-amber-dim)', color:'var(--pg-amber)' } },
    { id: 'urgent', label: 'Urgent', style: { borderColor:'var(--pg-red)',   background:'var(--pg-red-dim)',   color:'#f87171' } },
  ];

  return (
    <>
      <div className="vv-page-header">
        <div>
          <div className="vv-page-title">Nouveau signalement</div>
          <div className="vv-page-sub">Incident ou anomalie sur le parking</div>
        </div>
      </div>

      <div className="vv-content">
        <div className="vv-panel">
          <div className="vv-panel-title">
            <FlagIcon /> Déclarer un incident
          </div>

          <div className="vv-form-grid">

            {/* Type */}
            <div>
              <label className="vv-field-label">Type d'incident *</label>
              <select className="vv-select" value={form.type} onChange={e => set('type', e.target.value)}>
                {TYPES.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>

            {/* Niveau */}
            <div>
              <label className="vv-field-label">Niveau d'urgence *</label>
              <div className="vv-niveau-grid">
                {niveaux.map(n => (
                  <button
                    key={n.id}
                    className={`vv-reglement-btn${form.niveau === n.id ? ' active' : ''}`}
                    style={form.niveau === n.id ? n.style : {}}
                    onClick={() => set('niveau', n.id)}
                  >
                    {n.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Description */}
            <div className="vv-form-full">
              <label className="vv-field-label">Description *</label>
              <textarea
                className="vv-textarea"
                placeholder="Décrivez brièvement l'incident…"
                value={form.description}
                onChange={e => set('description', e.target.value)}
                rows={3}
              />
            </div>

            {/* Localisation */}
            <div>
              <label className="vv-field-label">Localisation (optionnel)</label>
              <select className="vv-select" value={form.localisation} onChange={e => set('localisation', e.target.value)}>
                {LOCALISATIONS.map(l => <option key={l} value={l}>{l || '— Optionnel —'}</option>)}
              </select>
            </div>

            {/* Plaque */}
            <div>
              <label className="vv-field-label">Plaque concernée (optionnel)</label>
              <input
                className="vv-input"
                type="text"
                placeholder="Ex: ABC 1234"
                value={form.plaque}
                onChange={e => set('plaque', e.target.value.toUpperCase())}
              />
            </div>

          </div>

          <div className="vv-form-actions">
            <button className="vv-btn vv-btn-ghost" onClick={() => setForm({ type: TYPES[0], niveau: 'moyen', description: '', localisation: '', plaque: '' })}>
              Annuler
            </button>
            <button className="vv-btn vv-btn-warn" onClick={handleSubmit}>
              <CheckIcon /> Enregistrer le signalement
            </button>
          </div>
        </div>
      </div>
    </>
  );
}